export default __webpack_public_path__ + "static/media/Business_Requests_6.f30a7554.svg";